import './PortCertificatesPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Tabs } from 'antd'
import PortBottomLayout from '../../common/PortBottomLayout'
import PortProductCertificates from './PortProductCertificates'
import PortQualityCertificates from './PortQualityCertificates'
import PortExtraCertificates from './PortExtraCertificates'

export default class PortCertificatesPage extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div>
        <div className="PortCertificates">
          <div className="PortCertificatesTitle">公司资质证书</div>
          <Tabs
            items={this.getTabsChildren()}
            size="large"
            type="card"
            style={{ fontFamily: 'MyCustomizedFont' }}
          />
        </div>

        <PortBottomLayout {...this.props} />
      </div>
    )
  }

  getTabsChildren = () => {
    return [
      {
        key: 'product',
        label: '质量管理',
        children: <PortProductCertificates />,
      },
      {
        key: 'quality',
        label: '环境管理',
        children: <PortQualityCertificates />,
      },
      {
        key: 'extra',
        label: '职业健康',
        children: <PortExtraCertificates />,
      },
    ]
  }
}
